import { TimelineItemTypeType, WeekDay } from '@app-types/index';
import {
  GetIntervalConfigurationsArgs,
  TimeSlotConfigurationsDataType,
  TimeSlotConfigurationType,
} from '@modules/timetable';
import { weekDays } from '@data/weekDays';

/**
 * Get interval configurations
 * @param timelineItems
 * @param week
 * @param batchClassIds
 * @param existingTimeSlotConfigurationDefaultValues
 */
export const getIntervalConfigurations = ({
  timelineItems,
  week,
  batchClassIds,
  timeSlotConfigurationDefaultValues: existingTimeSlotConfigurationDefaultValues,
}: GetIntervalConfigurationsArgs): TimeSlotConfigurationsDataType => {
  const timeSlotConfigurationDefaultValues: TimeSlotConfigurationsDataType = {
    ...existingTimeSlotConfigurationDefaultValues,
  };

  weekDays.forEach((weekDay, index) => {
    const intervalsForWeekDay = timelineItems.filter(
      (timelineItem) =>
        timelineItem.startTime.week() === week?.week() && // See whether the item belongs to the selected week
        batchClassIds?.includes(timelineItem.batchClassID.split('/')[1]) && // See whether the item belongs to the selected batch
        timelineItem.startTime.weekday() === index && // See whether the item belongs to the selected week day
        timelineItem.itemType === TimelineItemTypeType.interval, // See whether the item is an interval
    );

    if (intervalsForWeekDay.length > 0) {
      const timeSlotConfigurationDefaultValuesForDay: TimeSlotConfigurationType[] =
        timeSlotConfigurationDefaultValues[WeekDay[weekDay as WeekDay]];
      intervalsForWeekDay.forEach((interval) => {
        // Add only if the the same config does not exist
        const existingConfiguration = timeSlotConfigurationDefaultValuesForDay.find(
          (configuration) =>
            configuration.startTime === interval.startTime && configuration.endTime === interval.endTime,
        );

        if (!existingConfiguration) {
          timeSlotConfigurationDefaultValuesForDay.push({
            startTime: interval.startTime,
            endTime: interval.endTime,
            interval: true,
          });
        }
      });

      timeSlotConfigurationDefaultValues[WeekDay[weekDay as WeekDay]] = timeSlotConfigurationDefaultValuesForDay;
    }
  });

  return timeSlotConfigurationDefaultValues;
};
